import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ProfileDataService } from '../../../services/raintree/Transmission/profile-data.service';
import { ToastrService } from 'ngx-toastr';
import { DpSuccessMessageComponent } from '../../dp-success-message/dp-success-message.component';

@Component({
  selector: 'app-otp-dialog',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './otp-dialog.component.html',
  styleUrl: './otp-dialog.component.scss',
})
export class OtpDialogComponent implements OnInit {
  mobileOtp: string = '';
  emailOtp: string = '';
  finalOtp: string = '';
  number: string = '';
  email: string = '';
  otpTimer: number = 180;
  // timeLeft: number = 0
  bodyObj: any;
  resData: any = [];
  responseData: any = [];
  isOtpValid: boolean = false;
  isVerified: boolean = false;
  isEmailOtpValid: boolean = false;
  isMobileOtpValid: boolean = false;
  isDpVerified: boolean = false;
  phoneNo: any;
  phNo: any;
  dpSessionId: string = '';
  mobileSessionId: string = '';
  emailSessionId: string = '';

  private timerSubcription: Subscription | null = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<OtpDialogComponent>,
    private getProfileData: ProfileDataService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.data.currentTime === 0 && this.data.isUserVerfied) {
      this.sendingMobileOtp(this.data.dpMobileNo);
    }

    this.otpTimer = this.data.currentTime;

    if (this.data.currentTime != 0) {
      this.startTimer();
    }

    if (!this.data.isUserVerfied) {
      this.isVerified = true;
    } else if (this.data.isUserVerfied) {
      this.isVerified = false;
    }

    this.phoneNo = this.formatPhoneNumber(this.data.dpMobileNo);
  }

  formatPhoneNumber(phoneNumber: string) {
    if (phoneNumber.length > 9) {
      return (this.phoneNo = `**${phoneNumber.slice(-2)}`);
    }
    return phoneNumber;
  }

  restrictOtpInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[0-9]*$/;
    if (pattern.test(input) || input === 'Backspace') {
      return;
    } else {
      event.preventDefault();
    }
  }

  restrictEmailInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[a-zA-Z0-9@._-]+$/;
    if (pattern.test(input) || input === 'Backspace') {
      return;
    } else {
      event.preventDefault();
    }
  }
  removeCountryCode(phoneNumber: string) {
    if (phoneNumber.startsWith('+91')) {
      return phoneNumber.substring(3).trim();
    }
    return phoneNumber;
  }

  sendingMobileOtp(number: any) {
    this.phNo = this.removeCountryCode(number);
    if (number !== this.data.dpMobileNo) {
      this.bodyObj = {
        mobileNo: this.phNo.replace(/[^\d]/g, ''),
        duplicateCheck: true,
      };
    } else {
      this.bodyObj = {
        mobileNo: this.phNo.replace(/[^\d]/g, ''),
        initialCheck: true,
        checkEmail: this.data.currentEmail,
        checkMob: this.data.currentNo,
      };
    }

    this.getProfileData.getSentMobileOTP(this.bodyObj).subscribe({
      next: (res) => {
        if (res) {
          if (number !== this.data.dpMobileNo) {
            this.otpTimer = 180;
            this.startTimer();
            this.resData = res.data.sessionId;
            localStorage.setItem('mobileId', this.resData);
          } else {
            this.otpTimer = 180;
            this.startTimer();
            this.resData = res.data.sessionId;
            localStorage.setItem('dpSessionId', this.resData);
          }
        }
      },
      error: (error: any) => {
        if (localStorage.getItem('dpSessionId') == null) {
          this.dialogRef.close();
        }
        this.toaster.error(error);
      },
    });
  }

  verifyingMobileOtp(code: string, type: any) {
    let localId = localStorage.getItem('dpSessionId');
    let mobileId = localStorage.getItem('mobileId');
    if (type == 'secondOtp') {
      this.bodyObj = {
        verificationCode: code,
        sessionId: mobileId,
      };
    } else if (type == 'firstOtp') {
      this.bodyObj = {
        verificationCode: code,
        sessionId: localId,
      };
    } else if (type == 'sameOtp') {
      this.bodyObj = {
        verificationCode: code,
        sessionId: localId,
      };
    }
    this.getProfileData.getVerifyMobileOTP(this.bodyObj).subscribe({
      next: (res: any) => {
        if (res && type == 'firstOtp') {
          if (this.data.dpMobileNo != this.data.currentNo) {
            this.isVerified = res.data.verified;
            this.dpSessionId = res.data?.sessionId;
            localStorage.setItem('dpVerifySession', this.dpSessionId);

            if (this.data.currentNo && this.data.currentEmail) {
              this.sendEmailOtp(this.data.currentEmail);
              this.sendingMobileOtp(this.data.currentNo);
            } else if (this.data.currentNo) {
              this.sendingMobileOtp(this.data.currentNo);
            } else if (this.data.currentEmail) {
              this.sendEmailOtp(this.data.currentEmail);
            }
          } else if (this.data.dpMobileNo == this.data.currentNo) {
            this.isVerified = true;
            // this.isMobileOtpValid = true
            this.isMobileOtpValid = res.data?.verified;
            this.isOtpValid = true;
            this.mobileSessionId = res.data?.sessionId;
            this.dpSessionId = res.data?.sessionId;
            localStorage.setItem('dpVerifySession', this.dpSessionId);
          }

          // }
        } else if (res && (type == 'secondOtp' || type == 'sameOtp')) {
          // this.stopTimer()

          // if(res.data.verfied){
          this.isOtpValid = true;
          this.isMobileOtpValid = res.data?.verified;
          this.mobileSessionId = res.data?.sessionId;
          // }
        }
      },
      error: (error: any) => {
        if (type == 'firstOtp') {
          if (!this.isDpVerified) {
            this.isVerified = false;
          }
        } else if (type == 'secondOtp') {
          if (!this.isMobileOtpValid) {
            this.isMobileOtpValid = false;
          }
        }
        this.toaster.error(error);
      },
    });
  }

  startTimer() {
    if (this.timerSubcription) {
      this.timerSubcription.unsubscribe();
    }

    // this.otpTimer = 180
    this.timerSubcription = interval(1000).subscribe((value) => {
      if (this.otpTimer > 0) {
        this.otpTimer--;
      } else {
        this.timerSubcription?.unsubscribe();
      }
    });
  }

  resendOtp(type: any) {
    if (type == 'otp') {
      this.sendingMobileOtp(this.data.dpMobileNo);
    } else if (type == 'mobileOtp') {
      this.sendingMobileOtp(this.data.currentNo);
    } else if (type == 'emailOtp') {
      this.sendEmailOtp(this.data.currentEmail);
    }
  }

  verifyOtp(type: any) {
    if (type == 'mobileOtp') {
      this.verifyingMobileOtp(this.finalOtp, 'secondOtp');
    } else if (type == 'emailOtp') {
      this.verifyEmailOtp(this.emailOtp);
    } else if (type == 'Otp') {
      this.verifyingMobileOtp(this.mobileOtp, 'firstOtp');
    }
  }

  sendEmailOtp(email: string) {
    this.bodyObj = {
      email: email,
      duplicateCheck: true,
    };
    this.getProfileData.getSentEmailOTP(this.bodyObj).subscribe({
      next: (response) => {
        if (response) {
          this.otpTimer = 180;
          this.startTimer();
          this.responseData = response.data.sessionId;
          localStorage.setItem('emailId', this.responseData);
        }
      },
      error: (error: any) => {
        this.toaster.error(error);
      },
    });
  }

  verifyEmailOtp(code: string) {
    let emailId = localStorage.getItem('emailId');
    this.bodyObj = {
      verificationCode: code,
      sessionId: emailId,
    };
    this.getProfileData.getVerifyEmailOTP(this.bodyObj).subscribe({
      next: (response: any) => {
        if (response) {
          this.isOtpValid = true;
          this.isEmailOtpValid = response.data.verified;
          this.emailSessionId = response.data?.sessionId;
        }
      },
      error: (error: any) => {
        this.isEmailOtpValid = false;
        this.toaster.error(error);
      },
    });
  }

  onClose(type: any) {
    if (type == 'dpVerify') {
      this.dialogRef.close({
        type: 'dpVerify',
        pendingTime: this.otpTimer,
      });
    } else {
      this.dialogRef.close({
        type: 'mobileVerify',
        pendingTime: this.otpTimer,
        verfied: false,
      });
    }
  }

  updateProfile(details: any) {
    if (details == 'update') {
      const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
        panelClass: 'common-pannel-dialog-container',
        data: {
          mainHeading: `Your changes have been updated successfully`,
          // subHeading:
          //   'You can access all wish-lists from the ‘My wishlist’ menu on the Reach Defaulter page ',
          buttonValue: 'Check profile',
        },
      });
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          // if(this.timerSubcription || this.otpTimer > 0){
          // localStorage.removeItem('dpSessionId')
          // }
          localStorage.removeItem('dpSessionId');
          localStorage.removeItem('mobileId');
          localStorage.removeItem('emailId');
          if (this.timerSubcription) {
            this.timerSubcription.unsubscribe();
          }
          this.dialogRef.close({
            type: 'finalUpdate',
            email: this.data.currentEmail,
            contactNumber: this.data.currentNo,
            emailSessionId: this.emailSessionId,
            mobileSessionId: this.mobileSessionId,
            sessionId: localStorage.getItem('dpVerifySession'),
          });
        }
      });
    }
  }
}
